var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinGrayscale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M29.643 0A2.358 2.358 0 0 1 32 2.357v27.286A2.358 2.358 0 0 1 29.643 32H2.357A2.358 2.358 0 0 1 0 29.643V2.357A2.358 2.358 0 0 1 2.357 0h27.286zM4.87 12.522v15.304h4.87V12.522H4.87zm5.217-4.87c0-1.615-1.224-2.805-2.783-2.782-1.536 0-2.782 1.167-2.782 2.782 0 1.616 1.246 2.783 2.782 2.783s2.783-1.167 2.783-2.783zM27.13 18.208c0-4.752-2.92-6.29-5.54-6.29-2.447 0-3.98 1.56-4.439 2.51h-.065v-1.906h-4.564v15.304h4.738v-8.441c0-2.263 1.376-3.35 2.774-3.35 1.332 0 2.358.77 2.358 3.282v8.51h4.738v-9.619z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinGrayscale);
export default __webpack_public_path__ + "static/media/linkedin-grayscale.5f7bc26af03320a1050a3d1dbe692518.svg";
export { ForwardRef as ReactComponent };